module.exports = __webpack_public_path__ + "img/search.bcd000a7.svg";